export default "__VITE_ASSET__Cy6N8Iyx__"